var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionAnimations } from "./actionPelletAnimations";
var initial = {
    rewardPellets: [],
};
export var reducerAnimations = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionAnimations.AddPellets &&
        action.rewards &&
        action.origin &&
        action.id) {
        var reward = state.rewardPellets.find(function (r) { return r.id === action.id; });
        var rewardPellet = void 0;
        if (reward) {
            rewardPellet = {
                id: reward.id,
                origin: reward.origin,
                rewards: reward.rewards.concat(action.rewards),
            };
        }
        else {
            rewardPellet = {
                id: action.id,
                origin: action.origin,
                rewards: action.rewards,
            };
        }
        return __assign({}, state, { rewardPellets: state.rewardPellets.concat([rewardPellet]) });
    }
    else if (action.type === TypeActionAnimations.RemovePellets &&
        action.id &&
        state.rewardPellets.some(function (reward) { return reward.id === action.id; })) {
        return __assign({}, state, { rewardPellets: state.rewardPellets.filter(function (rewardPellet) { return rewardPellet.id !== action.id; }) });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/reducerAnimations.ts
// module id = 2519
// module chunks = 3